export default {"src":"/_next/static/media/nango-logo.83eccaba.svg","height":26,"width":109,"blurWidth":0,"blurHeight":0};